import { computed, makeObservable } from 'mobx'

import { normalizeMetadataSearchText } from './utils'

class SchemaMetadataStore {
    constructor(rootstore) {
        makeObservable(this, {
            metadataFields: computed,
            metadataGroups: computed,
        })
        this._rootstore = rootstore
    }

    get metadataFields() {
        const allitems = [
            ...Array.from(this._rootstore.data.definitions.values()),
            ...Array.from(this._rootstore.data.classes.values()),
            ...Array.from(this._rootstore.data.fields.values()),
        ].filter(item => !item.is_working_copy && !item.is_extended)

        let fieldNames = new Set()
        for (const item of allitems) {
            if (!item.metadata) continue
            for (const [name, metadatafield] of item.metadata.entries()) {
                if (['image', 'fieldpicker'].includes(metadatafield.type)) {
                    continue
                }
                fieldNames.add(name)
            }
        }
        return Array.from(fieldNames).sort()
    }

    get metadataGroups() {
        let groupNames = new Set()
        for (const metadataField of this.metadataFields) {
            const groupName = metadataField.split('.').shift()
            groupNames.add(groupName)
        }
        return Array.from(groupNames).sort()
    }

    async fetchGroups(searchText, language) {
        const allGroups = this.metadataGroups
        if (!searchText || !searchText.trim().length) {
            return allGroups
        }
        const searchWords = normalizeMetadataSearchText(searchText).split(' ')
        return allGroups.filter(groupName => {
            // do a match: in name
            // first, normalize (validName)
            // second, split on spaces
            // then, match all words
            const normalizedGroupName = normalizeMetadataSearchText(groupName)
            for (const word of searchWords) {
                if (!word.length) continue
                if (!normalizedGroupName.includes(word)) {
                    return false
                }
            }
            return true
        })
    }

    async fetchGroupFields(groupName, language) {
        const allFields = this.metadataFields
        const filterGroupName = groupName + '.'
        return allFields
            .filter(fieldName => {
                if (!fieldName.startsWith(filterGroupName)) {
                    return false
                }
                return true
            })
            .map(fieldName => fieldName.substring(filterGroupName.length))
    }
}

export default SchemaMetadataStore
